import { render, staticRenderFns } from "./FolderOwnership.vue?vue&type=template&id=3b2b2bbd&scoped=true"
import script from "./FolderOwnership.vue?vue&type=script&lang=js"
export * from "./FolderOwnership.vue?vue&type=script&lang=js"
import style0 from "./FolderOwnership.vue?vue&type=style&index=0&id=3b2b2bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b2bbd",
  null
  
)

export default component.exports